import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white border-0 rounded-3 mb-4 client-ratings-bg" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4" }
const _hoisted_4 = { class: "dropdown select-dropdown" }
const _hoisted_5 = {
  class: "dropdown-toggle border text-body rounded-2 bg-gray-100",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  class: "d-flex align-items-center mb-4",
  style: {"gap":"12px"}
}
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = {
  class: "fw-semibold fs-14",
  style: {"margin-bottom":"3px"}
}
const _hoisted_13 = { class: "fs-12 text-body" }
const _hoisted_14 = {
  class: "fs-16 text-secondary mb-20",
  style: {"line-height":"1.5"}
}
const _hoisted_15 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_16 = {
  class: "d-flex align-items-center",
  style: {"gap":"1px"}
}
const _hoisted_17 = {
  class: "fs-12",
  style: {"margin-left":"2px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "mb-0" }, "Client Ratings", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.currentFilter), 1),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
              return (_openBlock(), _createElementBlock("li", { key: filter }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["dropdown-item text-secondary py-2 px-3", { active: _ctx.currentFilter === filter }]),
                  onClick: ($event: any) => (_ctx.changeFilter(filter))
                }, _toDisplayString(filter), 11, _hoisted_7)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: false,
        preventClicks: true,
        loop: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: '.swiper-pagination-client-ratings',
          clickable: true,
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 2 },
          992: { slidesPerView: 2 },
          1200: { slidesPerView: 2 },
          1440: { slidesPerView: 3 },
          1850: { slidesPerView: 3 },
        },
        modules: _ctx.modules,
        class: "client-ratings-slide"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRatings, (rating, index) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(`border-0 rounded-3 ${rating.bgColor} p-25`)
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("img", {
                        src: rating.avatar,
                        style: {"width":"38px","height":"38px","top":"-2px"},
                        class: "rounded-circle position-relative",
                        alt: rating.name
                      }, null, 8, _hoisted_10)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h6", _hoisted_12, _toDisplayString(rating.name), 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(rating.location), 1)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_14, " \"" + _toDisplayString(rating.comment) + "\" ", 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                        return _createElementVNode("i", {
                          key: star,
                          class: _normalizeClass([_ctx.getStarClass(star, rating.rating), "lh-1"])
                        }, null, 2)
                      }), 64)),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(rating.rating.toFixed(1)), 1)
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ri-double-quotes-r fs-30 text-white lh-1" }, null, -1))
                  ])
                ], 2)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "swiper-pagination-client-ratings text-center mt-4 lh-1" }, null, -1))
    ])
  ]))
}